import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppSvgIconComponent, ThemeMode, ThemeService } from '@vallift/ngl';

@Component({
  selector: 'app-home-footer-section',
  imports: [AppSvgIconComponent],
  templateUrl: './home-footer-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class HomeFooterSectionComponent {
  readonly themeService = inject(ThemeService);

  protected readonly themeModes: {
    label: string;
    value: ThemeMode;
    icon: string;
  }[] = [
    { label: 'Light', value: 'light', icon: 'assets/icons/weather-sunny.svg' },
    { label: 'Dark', value: 'dark', icon: 'assets/icons/moon-waning-crescent.svg' },
    { label: 'Auto', value: 'system', icon: 'assets/icons/monitor.svg' },
  ];

  protected setTheme(mode: ThemeMode): void {
    this.themeService.setThemeMode(mode);
  }
}
